import { render, staticRenderFns } from "./CustomerTodo.vue?vue&type=template&id=21be1283&scoped=true"
import script from "./CustomerTodo.vue?vue&type=script&lang=js"
export * from "./CustomerTodo.vue?vue&type=script&lang=js"
import style0 from "./CustomerTodo.vue?vue&type=style&index=0&id=21be1283&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21be1283",
  null
  
)

export default component.exports